<template>
    <section class="user-center">
        <div class="content">
            <div class="left">
                <ul class="left-nav">
                    <li :class="activeNav=='nav1'?'left-nav-item active':'left-nav-item'" @click="activeNav='nav1'">Userinfo</li>
                    <li :class="activeNav=='nav2'?'left-nav-item active':'left-nav-item'" @click="activeNav='nav2'" v-if="!loginAsChild||loginAsChild=='false'">Subaccount management</li>
                    <li :class="activeNav=='nav3'?'left-nav-item active':'left-nav-item'" @click="activeNav='nav3'">Change password</li>
                    <li :class="activeNav=='nav4'?'left-nav-item active':'left-nav-item'" @click="activeNav='nav4'"  v-if="!loginAsChild||loginAsChild=='false'">Booking alert Settings</li>
                </ul>
            </div>
            <div class="right">
                <!-- right-content -->
                <div :class="activeNav=='nav1'?'right-content active':'right-content'"  >
                    <div class="right-content-head">
                        Userinfo
                    </div>
                    <div class="right-content-body">
                        <p><span>Company Name：</span>{{userInfo.SupplierName}}</p>
                        <p><span>User ID：</span>{{userInfo.userName}}</p>
                    </div>
                </div>
                <!-- right-content -->
                <div :class="activeNav=='nav2'?'right-content active':'right-content'"  @click="activeNav='nav2'"  v-if="!loginAsChild||loginAsChild=='false'"> 
                    <div class="right-content-head">
                        Subaccount management
                        <a class="head-btn allot-child-accont-btn" @click="toAllotChildAccount">Assign subaccount</a>
                    </div>
                    <div class="right-content-body">
                        <div class="filter">
                            <div class="form-inline-contorl">
                                <label class="title">Number：</label>
                                <input type="text" v-model="subUserNo" />
                            </div>
                            <div class="form-inline-contorl">
                                <label class="title">Name：</label>
                                <input type="text" v-model="subUserName">
                            </div>
                            <div class="form-inline-contorl">
                                <label class="title">State：</label>
                                <select name="" id="" v-model="subUserStatus">
                                    <option :value="true">Active</option>
                                    <option :value="false">Inactive</option>
                                </select>
                            </div>
                            <div class="form-inline-contorl e-pull-right">
                                <div class="search-btn" @click="getSubUserList">search</div>
                            </div>
                        </div>
                        <table class="child-accont-table" cellspacing="0">
                            <thead>
                                <tr> 
                                    <td width="15%">Number</td>
                                    <td width="10%">Name</td>
                                    <td width="15%">Phone</td>
                                    <td width="15%">Fax</td>
                                    <td width="10%">State</td>
                                    <td width="35%">Operator</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in subUserList" v-if="user.NO.indexOf(subUserNo)>-1&&user.Name.indexOf(subUserName)>-1&&subUserStatus==user.IsActive">
                                    <td>
                                        {{user.NO}}
                                        <!-- <span>{{user.NO}}</span> -->
                                    </td>
                                    <td>
                                        {{user.Name}}
                                       
                                    </td>
                                    <td>{{user.Phone}}</td>
                                    <td>{{user.Fax}}</td>
                                    <td> 
                                        <span v-if="user.IsActive">Active</span>
                                        <span v-if="!user.IsActive">Inactive</span>
                                        
                                    </td>
                                    <td>
                                        <!-- <a href="javascript:void(0)">删除</a> -->
                                        <a @click="toAllotUserAuth(user)">Assign permissions</a>
                                        <a @click="toAllotHotels(user)">Assign hotel</a>
                                        <a @click="toResetPassword(user)">Reset passwords</a>
                                        <a @click="eidtSubUser(user.NO,true,user.Permissionons)" v-if="!user.IsActive">Enable</a>
                                        <a @click="eidtSubUser(user.NO,false,user.Permissionons)" v-if="user.IsActive">Disabled</a>
                                    </td>
                                </tr>
                                <tr v-if="!subUserList||subUserList.length<=0">
                                    <td colspan="6">No relevant data...</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- right-content -->
                <div :class="activeNav=='nav3'?'right-content active':'right-content'"  @click="activeNav='nav3'">
                    <div class="right-content-head">
                        Change password
                    </div>
                    <div class="right-content-body">
                        <div class="e-form">
                            <div class="form-contorl">
                                <label class="title" style="width:190px;">Current Password：</label>
                                <input type="password" v-model="OldPwd" />
                            </div>
                            <div class="form-contorl">
                                <label class="title" style="width:190px;">New Password：</label>
                                <input type="password" v-model="NewPwd" />
                            </div>
                            <div class="form-contorl">
                                <label class="title" style="width:190px;">Confirm New Password：</label>
                                <input type="password" v-model="NewPwd2" />
                            </div>
                            <div class="form-contorl">
                                <label class="title"></label>
                                <div class="submit-btn" @click="updatePassword">submit</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- right-content -->
                <div :class="activeNav=='nav4'?'right-content active':'right-content'"  @click="activeNav='nav4'"  v-if="!loginAsChild||loginAsChild=='false'">
                    <div class="right-content-head">
                        Booking reminder Settings
                    </div>
                    <div class="right-content-body">
                        <div class="subTitle">SMS reminder</div>
                        <div class="e-form">
                            <div class="form-contorl">
                                <label class="title" style="width:80px;">Mobile：</label>
                                <input type="text" v-model="Phone" />
                            </div>
                            <div class="form-contorl">
                                <label class="title"></label>
                                <div class="submit-btn" @click="updateNotifyPhone">submit</div>
                            </div>
                        </div>
                    </div>
                    <div class="right-content-body">
                        <div class="subTitle">Email reminder</div>
                        <div class="e-form">
                            <div class="form-contorl">
                                <label class="title" style="width:80px;">Email：</label>
                                <input type="text" v-model="Email" />
                            </div>
                            <div class="form-contorl">
                                <label class="title"></label>
                                <div class="submit-btn" @click="updateNotifyEmail">submit</div>
                            </div>
                        </div>
                    </div>
                    <div class="right-content-body">
                        <div class="subTitle">Wechat reminder</div>
                        <div class="e-form">
                            <div class="form-contorl">
                                <p>1、Follow WeChat public accounts “龙腾捷旅订房集团”；</p>
                                <p>2、Click on “系统登录” to enter the “控房易”；</p>
                                <p>3、Log in with your username and password；</p>
                                <p>4、Click on “我的信息” to open “是否接受订单通知”</p>
                            </div>
                        </div>
                    </div>
                </div>

                <section class="section-footer">
                    <p>Booking and after-sales:（020-2214 6801） Domestic Products:（0755-82365588-1） Overseas Products:（0755-82365588-3）</p>
              	    <p>H.K. Products:（0755-82365588-2） Macau Products:（0756-8281308）</p>
                    <p>Copyright2013-2017,cnbooking.net.All rights reserved. <a href="https://beian.miit.gov.cn/">粤ICP备09018804号</a> <a href="https://beian.mps.gov.cn/#/query/webSearch"> <img style="vertical-align: sub;" src="./../../assets/images/element.png" alt=""> 粤公网安备 44030302000401号</a></p>
                </section>
            </div>

        </div>
        <AllotChildAccount :userInfo="userInfo" @done="getSubUserList"> </AllotChildAccount>
        <AllotUserAuth :userAuth="userAuth" @done="getSubUserList"> </AllotUserAuth>
        <AllotHotels :userHotel="userHotel" @done="getSubUserList"> </AllotHotels>
        <ResetPassword :userPwd="userPwd" @done="getSubUserList"> </ResetPassword>
    </section>
</template>

<script>
import AllotChildAccount from './AllotChildAccont.vue'
import AllotUserAuth from './AllotUserAuth.vue'
import AllotHotels from './AllotHotels.vue'
import ResetPassword from './ResetPassword.vue'
export default {
    name: 'user',
    components:{
        AllotChildAccount,
        AllotUserAuth,
        AllotHotels,
        ResetPassword
    },
    data () {
        return {
            userInfo:JSON.parse(this.dao.get('res')),
            userAuth:JSON.parse(this.dao.get('res')),
            userHotel:JSON.parse(this.dao.get('res')),
            userPwd:JSON.parse(this.dao.get('res')),
            activeNav:'nav1',
            subUserList:'',
            //子账户管理
            subUserNo:'',
            subUserName:'',
            subUserStatus:true,
            //主帐号管理
            OldPwd:'',
            NewPwd:'',
            NewPwd2:'',
            //短信提醒
            Phone:'',
            Email:'',
            loginAsChild:this.dao.get('loginAsChild')
        }
    },
    watch:{
        $route(val){
          
            this.activeNav=val.query.activeNav||'nav1';

        }
    },

    methods:{
        toAllotChildAccount(){
            this.$nextTick(function () {
                this.$set(this.userInfo,'isShow',true);
        　  });
        },
        toAllotUserAuth(user){
            this.userAuth=user;
            this.$nextTick(function () {

                this.$set(this.userAuth,'isAuthShow',true);
        　  });
        },
        toAllotHotels(user){
            this.userHotel=user;
            this.$nextTick(function () {
                this.$set(this.userHotel,'isHotelShow',true);
        　  });
        },
        toResetPassword(user){
            this.userPwd=user;
            this.$nextTick(function () {
                this.$set(this.userPwd,'isPwdShow',true);
        　  });
        },

        getSubUserList(){           
            var that=this;
            that.getRequest({
                url: that.Api.getSubUserList
            }).then(res => {
                if (res&&res.Result.length>0) {
                   
                    that.subUserList=res.Result;
                } else {
                    that.subUserList=[];
                    // that.error({ title: '提示', content: '没有查询到相关数据' });
                }
            });
        },
        eidtSubUser(number,status,permission){           
            var that=this;
            var params={
                NO:number,
                IsActive:status,
                Pwd:'',
                Permissions:permission,
                Hotels:null
            }
            that.patchRequest({
                url: that.Api.eidtSubUser,
                params:params
            }).then(res => {
                if (res&&res.IsSuccess) {
                    that.error({ title: 'Tips', content: 'Update successfully' });
                    that.getSubUserList();
                } else {
                    that.error({ title: 'Tips', content: 'Update error, please try again' });
                }
            });
        },
        getNotifyPhone(){
            var that=this;
            that.getRequest({
                url: that.Api.getNotifyPhone
            }).then(res => {
                if (res&&res.Result) {
                   
                    that.Phone=res.Result;
                } else {
                    // that.error({ title: '提示', content: '没有查询到相关数据' });
                }
            });
        },
        getNotifyEmail(){
            var that=this;
            that.getRequest({
                url: that.Api.getNotifyEmail
            }).then(res => {
                if (res&&res.Result) {
                   
                    that.Email=res.Result;
                } else {
                    // that.error({ title: '提示', content: '没有查询到相关数据' });
                }
            });
        },
       
        updateNotifyPhone(){
            var that=this;
            const reg = /^1[3-9]\d{9}$/;
            if (!reg.test(that.Phone)) {
                that.error({ title: 'Tips', content: 'Please enter a valid phone number.' });
                return;
            }
            var params={
                Phone:that.Phone
            };

            that.postRequest({
                url: that.Api.updateNotifyPhone,
                params:params
            }).then(res => {
                if (res&&res.IsSuccess) {
                    that.error({ title: 'Tips', content: 'Update successfully' });
                    that.activeNav='nav1';
                    that.getNotifyPhone();
                    that.getNotifyEmail();
                   
                } else {
                    that.error({ title: 'Tips', content: 'Update error, please try again' });
                }
            });
        },

        updateNotifyEmail(){
            var that=this;
            const reg = /^[^\s]+@[a-z0-9]+\.[a-z]{2,4}$/;
            if (!reg.test(that.Email)) {
                that.error({ title: 'Tips', content: 'Please enter a valid email address.' });
                return;
            }
            var params={
                Email:that.Email
            };

            that.postRequest({
                url: that.Api.updateNotifyPhone,
                params:params
            }).then(res => {
                if (res&&res.IsSuccess) {
                    that.error({ title: 'Tips', content: 'Update successfully' });
                    that.activeNav='nav1';
                    that.getNotifyPhone();
                    that.getNotifyEmail();
                } else {
                    that.error({ title: 'Tips', content: 'Update error, please try again' });
                }
            });
        },


        updatePassword(){

            var that=this;
            var OldPwd=that.OldPwd;
            var NewPwd=that.NewPwd;
            var NewPwd2=that.NewPwd2;

            if(!OldPwd){
                that.error({title: 'Update error',content: 'Please enter old password'})
                return;
            }
            if(!NewPwd){
                that.error({title: 'Update error',content: 'Please enter new password'})
                return;
            }
            if(NewPwd.length<6||NewPwd.length>32){
                that.error({title: 'Update error',content: 'The password contains a minimum of 6 characters and a maximum of 32 characters'})
                return;
            }
            if(!NewPwd2){
                that.error({title: 'Update error',content: 'Please enter confirmation password'})
                return;
            }
            if(NewPwd!=NewPwd2){
                that.error({title: 'Update error',content: 'The two password entries are different'})
                return;
            }


            var params={
                OldPwd:OldPwd,
                NewPwd:NewPwd,
                NewPwd2:NewPwd
            }
            that.postRequest({
                url: that.Api.updatePassword,
                params:params
            }).then(res => {
                if (res&&res.IsSuccess) {
                    that.error({ title: 'Tips', content: 'Update successfully'  });
                    that.activeNav='nav1';
                } else {
                    that.error({ title: 'Tips', content: res.Msg||'Update error, please try again' });
                }
            });
        }
    },
    mounted(){
      this.getSubUserList();
      this.getNotifyPhone();
      this.getNotifyEmail();
      this.activeNav=this.$route.query.activeNav||'nav1';
    }
}
</script>





// WEBPACK FOOTER //
// src/components/user/User.vue